import React, { useState, useRef, useEffect } from "react";
import {
  TextField,
  Grid,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  TextareaAutosize,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import CloseIcon from "@mui/icons-material/Close";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import ItemMasterHelp from "../../../Helper/SystemmasterHelp";
import SystemHelpMaster from "../../../Helper/SystemmasterHelp";
import BrandMasterHelp from "../../../Helper/BrandMasterHelp";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../..";
import AddButton from "../../../Common/Buttons/AddButton";
import EditButton from "../../../Common/Buttons/EditButton";
import DeleteButton from "../../../Common/Buttons/DeleteButton";
import OpenButton from "../../../Common/Buttons/OpenButton";
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo";
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";
import Swal from "sweetalert2";
import DetailAddButtom from "../../../Common/Buttons/DetailAddButton";
import DetailCloseButton from "../../../Common/Buttons/DetailCloseButton";
import DetailUpdateButton from "../../../Common/Buttons/DetailUpdateButton";
import { OutwordPostDateRecordLock } from "../../../Common/PostDateLock/PostDateRangeCheck";
import { validateDocumentDate } from "../../../Common/ValidateDateRange/ValidateDateRange";
import formatTruckNumber from "../../../Common/FormatFunctions/FormatTruckNumber";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import { ApprovalRounded, Update } from "@mui/icons-material";
import AwakentryReport from "./AwakReport";
// Common style for all table headers

//Global Variables
var newAwakid = "";
var partyName = "";
var partyCode = "";
var newId = "";
var millName = "";
var millCode = "";
var unitName = "";
var unitCode = "";
var brokerName = "";
var brokerCode = "";
var godownCode = "";
var godownName = "";
var itemName = "";
var LineName = "";
var item_code = "";
var gstrate = "";
var gstRateCode = "";
var gstName = "";
var brandName = "";
var lineCode = "";
var transportName = "";
var transportCode = "";
var billToName = "";
var billToCode = "";
var selectedfilter = "";
var PartyMobNo = "";
var TransportMobNo = "";
var UnitMobNo = "";
var millgstno = "";
var gc = "";

const headerCellStyle = {
  fontWeight: "bold",
  backgroundColor: "#3f51b5",
  color: "white",
  padding: "6px",
  textAlign: "center",
  "&:hover": {
    backgroundColor: "#303f9f",
    cursor: "pointer",
  },
};

//API URL
const API_URL = process.env.REACT_APP_API;

const AwakEntry = () => {
  const companyCode = sessionStorage.getItem("Company_Code");
  const Year_Code = sessionStorage.getItem("Year_Code");
  const username = sessionStorage.getItem("username");
  const TCSApplicable = sessionStorage.getItem("TCSApplicable");
  const User_Id = sessionStorage.getItem("User_ID");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const navigatedRecord = searchParams.get("navigatedRecord");
  const permissions = location.state?.permissionsData;

  //State Management
  const [users, setUsers] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMode, setPopupMode] = useState("add");
  const [selectedUser, setSelectedUser] = useState({});
  const [deleteMode, setDeleteMode] = useState(false);
  const [itemCode, setItemCode] = useState("");
  const [item_Name, setItemName] = useState("");
  const [godowncode, setgodowncode] = useState("");
  const [godowncodeid, setgodowncodeid] = useState("");
  const [godown_name, setgodown_name] = useState("");
  const [line_code, setLineCode] = useState("");
  const [line_name, setLineName] = useState("");
  const [LineAccoid, setLineAccoid] = useState("");
  const [itemCodeAccoid, setItemCodeAccoid] = useState("");
  const [auctionValue, setAuctionValue] = useState("N");
  const [saleBillPopupOpen, setSaleBillPopupOpen] = useState(false);
  const [saleBillData, setSaleBillData] = useState([]);
  const [saleBillLoading, setSaleBillLoading] = useState(false);
  const [formDataDetail, setFormDataDetail] = useState({
    Awak_Qty: 0.0,
    wt: 0.0,
    netwt: 0.0,
    pata: 0.0,
    ic: "",
    balance: 0.0,
    AuctionMark: "N",
    AuctionDate: new Date().toISOString().split("T")[0],
    Customer_Code: 0,
    cc: 0,
    oldCustomerCode: 0,
    oldcc: 0,
    oldsalerate: 0.00,
    Salerate: 0.00,
    Readyforsale: "N",
    Auction: "",
    sold: "N",
    salebilldocno: 0,
    ApprovedDate: null,
    RejectDate: null,
    detail_id: 1,
    SrNo: 0,
    SaudaDate: new Date().toISOString().split("T")[0],
  });

  //Head Section State Managements
  const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
  const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
  const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
  const [editButtonEnabled, setEditButtonEnabled] = useState(false);
  const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
  const [backButtonEnabled, setBackButtonEnabled] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [highlightedButton, setHighlightedButton] = useState(null);
  const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [lastTenderDetails, setLastTenderDetails] = useState([]);
  const [lastTenderData, setLastTenderData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [gstNo, setGstNo] = useState("");
  const [isHandleChange, setIsHandleChange] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenEInvoice, setIsOpenEInvoice] = useState(false);
  const [isOpenEwayBill, setIsOpenEwayBill] = useState(false);
  const [billToManuallySet, setBillToManuallySet] = useState(false);
  const [shipToManuallySet, setShipToManuallySet] = useState(false);
  const [bill_To_Name, setBillToName] = useState("");
  const [ship_To_Name, setShipToName] = useState("");
  const [isFarmerSelected, setIsFarmerSelected] = useState(false);
  const [bankPopupOpen, setBankPopupOpen] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);
  const [bankLoading, setBankLoading] = useState(false);
  const [newAccoid, setNewAccoid] = useState(null);
  const [originalBankDetails, setOriginalBankDetails] = useState(null);
  const [originalContactData, setOriginalContactData] = useState([]);
  const [isDirty, setIsDirty] = useState(false);

  const [adjustRow, setAdjustRow] = useState(null);
  const [adjustValue, setAdjustValue] = useState("");

  const selectedRecord = location.state?.selectedRecord;
  const navigate = useNavigate();
  const inputRef = useRef(null);

  console.log(selectedRecord)

  //SET Focus to the ADD Buttons.
  const addButtonRef = useRef(null);
  const firstInputRef = useRef(null);
  const setFocusToFirstField = () => {
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  };

  //Initial Formdata

  const initialFormData = {
    Doc_No: "",
    Doc_Date: new Date().toISOString().split("T")[0],
    Broker_code: "",
    Truck_No: "",
    Godown_code: "",
    Company_Code: companyCode,
    Year_Code: Year_Code,
    Ac_code: "",
    mobile: "",
    ac: 0,
    gc: 0,
    Bc: 0,
    Created_By: "",
    Modified_By: "",
    AwakQty: 0.0,

  };

  //ALL Help Section State managements
  const [formData, setFormData] = useState(initialFormData);
  const [billFrom, setBillFrom] = useState("");
  const [partyMobNo, setPartyMobNo] = useState("");
  const [billTo, setBillTo] = useState("");
  const [mill, setMill] = useState("");
  const [millname, setMillName] = useState("");
  const [millGSTNo, setMillGSTNo] = useState("");
  const [shipTo, setShipTo] = useState("");
  const [shipToMobNo, setShipToMobNo] = useState("");
  const [gstCode, setGstCode] = useState("");
  const [transport, setTransport] = useState("");
  const [transportMob, setTransportMob] = useState("");
  const [broker, setBroker] = useState("");
  const [framer, setFramer] = useState("");
  const [GstRate, setGstRate] = useState(0.0);
  const [matchStatus, setMatchStatus] = useState(null);
  const [isPalaManuallyChanged, setIsPalaManuallyChanged] = useState(false);

  //Validation Input feilds
  const validateNumericInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9.-]/g, "");
  };

  const formatTruckNumber = (value) => {
    const cleanedValue = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    return cleanedValue.length <= 10 ? cleanedValue : cleanedValue.substring(0, 10);
  };

  //Handle Records OnChange Method
  const handleChange = (event) => {
    const { name, value } = event.target;
    const updatedValue = name === "Truck_No" ? formatTruckNumber(value) : value;
    setFormData((prevData) => ({
      ...prevData,
      [name]: updatedValue,
    }));
  };


  const checkGulSalebillUsage = async (Awak_No) => {
    try {
      const res = await axios.get(`${API_URL}/check-Gulsalebill-usage`, {
        params: {
          doc_no: Awak_No,
          Company_Code: companyCode,
          Year_Code: Year_Code, // Uncomment if needed
        },
      });

      return res.data?.isUsed ?? false; // Always return a boolean
    } catch (err) {
      console.error("Error checking Proforma usage:", err);
      return false; // Fail-safe
    }
  };

  const checkGulSalebillForDetailIdUsage = async (awakdetailId) => {
    try {
      const res = await axios.get(`${API_URL}/check-salebilldetailId-usage`, {
        params: {
          Id: awakdetailId,
          Company_Code: companyCode,
          Year_Code: Year_Code,
        },
      });

      return res.data?.isUsed ?? false; // Always return a boolean
    } catch (err) {
      console.error("Error checking Proforma usage:", err);
      return false; // Fail-safe
    }
  };

  const checkAwakNoUsage = async (Awak_No) => {
    try {
      const res = await axios.get(`${API_URL}/check-AwakNo-usage`, {
        params: {
          Doc_No: Awak_No,
          Company_Code: companyCode,
        },
      });

      return res.data || { isUsed: false };
    } catch (err) {
      console.error("Error checking Awak No usage:", err);
      return { isUsed: false }; // fail-safe
    }
  };



  //handle the Date OnChange Values
  const handleDateChange = (event, fieldName) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: event.target.value,
    }));
  };

  useEffect(() => {
    if (isHandleChange) {
      handleCancel();
      setIsHandleChange(false);
    }
  }, []);

  //fetchLast Records to get the next doc no
  const fetchLastRecord = () => {
    fetch(
      `${API_URL}/get_next_docno?Company_Code=${companyCode}&Year_Code=${Year_Code}&Doc_No=${formData.Doc_No}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch last record");
        }
        return response.json();
      })
      .then((data) => {
        const newDocNo = data.next_doc_no;
        setFormData((prevState) => ({
          ...prevState,
          Doc_No: newDocNo,
        }));
      })
      .catch((error) => {
        console.error("Error fetching last record:", error);
      });
  };

  //handle record Add.
  const handleAddOne = async () => {

    setAddOneButtonEnabled(false);
    setSaveButtonEnabled(true);
    setCancelButtonEnabled(true);
    setEditButtonEnabled(false);
    setDeleteButtonEnabled(false);
    setIsEditMode(false);
    setIsEditing(true);
    fetchLastRecord();
    setFormData(initialFormData);
    setFormData((prevState) => ({
      ...initialFormData,
      Doc_No: prevState.Doc_No,
      Godown_code: godowncode.code,
      gc: godowncode.accoid,
      Company_Code: companyCode,
      Year_Code: Year_Code,
    }));
    partyName = "";
    partyCode = "";
    millName = "";
    millCode = "";
    unitName = "";
    unitCode = "";
    brokerName = "";
    brokerCode = "";
    itemName = "";
    LineName = "";
    item_code = "";
    gstrate = "";
    gstRateCode = "";
    brandName = "";
    lineCode = "";
    transportName = "";
    transportCode = "";
    billToName = "";
    billToCode = "";
    gstName = "";
    newId = "";
    godownCode = "";
    godownName = godowncode.GoDownName || "";
    setgodowncode("");
    setgodown_name("");
    setLastTenderDetails([]);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  //handle Edit record functionality.
  const handleEdit = async () => {

    // const isUsed = await checkGulSalebillUsage(formData.Doc_No);

    // if (isUsed) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Cannot Edit",
    //     text: "This Doc No is already used in Gul Sale Bill. You cannot delete it.",
    //     confirmButtonColor: "#d33",
    //   });
    //   return;
    // }
    const Post_Date = sessionStorage.getItem("Post_Date");
    const Outword_Date = sessionStorage.getItem("Outword_Date")
    if (await OutwordPostDateRecordLock(formData.Doc_Date, Post_Date, Outword_Date)) {
      return;
    }

    // if (
    //   (formData.einvoiceno && formData.einvoiceno.trim() !== "" && formData.ackno && formData.ackno.trim() !== "") ||
    //   (formData.EWay_Bill_No && formData.EWay_Bill_No.trim() !== "")
    // ) {
    let message = "";

    //   if (formData.einvoiceno && formData.einvoiceno.trim() !== "" && formData.ackno && formData.ackno.trim() !== "") {
    //     message += "E-Invoice has already been generated for this record.";
    //   }

    //   if (formData.EWay_Bill_No && formData.EWay_Bill_No.trim() !== "") {
    //     message += (message ? "\n" : "") + "E-WayBill has already been generated for this record.";
    //   }

    Swal.fire({
      icon: "warning",
      text: message,
      confirmButtonColor: "#d33",
    });


    if (!formData?.Id) {
      console.error(
        "❌ Cannot edit: formData.Id is missing or invalid",
        formData
      );
      Swal.fire({
        icon: "error",
        title: "Invalid Record",
        text: "The selected record is missing an ID.",
      });
      return;
    }

    console.log("✅ Sending Id:", formData.Id); // should not be undefined or empty

    axios
      .get(
        `${API_URL}/AwakEntryByid?Id=${formData.Id}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
      )
      .then((response) => {
        const data = response.data;
        // const isLockedNew = data.last_head_data.LockedRecord;
        // const isLockedByUserNew = data.last_head_data.LockedUser;

        // if (isLockedNew) {
        //   Swal.fire({
        //     icon: "warning",
        //     title: "Record Locked",
        //     text: `This record is locked by ${isLockedByUserNew}`,
        //     confirmButtonColor: "#d33",
        //   });
        //   return
        // }
        // else {
        //   lockRecord();
        // }
        setFormData({
          ...formData,
          ...data.last_head_data,
        });
        setIsEditMode(true);
        setAddOneButtonEnabled(false);
        setSaveButtonEnabled(true);
        setCancelButtonEnabled(true);
        setEditButtonEnabled(false);
        setDeleteButtonEnabled(false);
        setBackButtonEnabled(true);
        setIsEditing(true);
      })
      .catch((error) => {
        // window.alert("This record is already deleted! Showing the previous record.");
      });
  };

  // Record save and update functionality
  const handleSaveOrUpdate = async () => {
    const Post_Date = sessionStorage.getItem("Post_Date");
    const Outword_Date = sessionStorage.getItem("Outword_Date")
    if (await OutwordPostDateRecordLock(formData.Doc_Date, Post_Date, Outword_Date)) {
      return;
    }

    const accountingYearData = sessionStorage.getItem("Accounting_Year");
    const formattedEntryDate = formData.Doc_Date;
    const isValid = validateDocumentDate(
      formattedEntryDate,
      accountingYearData
    );

    if (!isValid) {
      return;
    }

    if (
      users.length === 0 ||
      users.every(
        (user) => user.rowaction === "DNU" || user.rowaction === "delete"
      )
    ) {
      Swal.fire({
        text: "Please add at least one entry in the detail grid.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    setIsEditing(true);
    setIsLoading(true);

    let headData = {
      ...formData,

      ...(isEditMode
        ? {
          Modified_By: username,
          // User_Id: User_Id,
        }
        : {
          Created_By: username,
        }),
    };
    delete headData[""];
    // delete headData.RateDiffAmount;
    if (isEditMode) {
      delete headData.Id;
      headData.Modified_By = username
      // headData.User_Id = User_Id
    } else {
      headData.Created_By = username;
    }


    const detailData = users.map((user) => ({
      rowaction: user.rowaction,
      Id: user.Id,
      detail_id: user.detail_id,
      Awak_Id: user.Awak_Id,
      Item_Code: user.Item_Code,
      Awak_Qty: user.Awak_Qty,
      wt: user.wt,
      netwt: user.netwt,
      balance: user.balance,
      sold: user.sold,
      ic: user.ic,
      pata: user.pata,
      Company_Code: companyCode,
      Year_Code: Year_Code,
      Created_By: username,
      Modified_By: username,
      Line_code: user.Line_code,
      lc: user.lc,
      AuctionMark: "N",
      AuctionDate: user.AuctionDate,
      Customer_Code: 0,
      cc: 0,
      oldCustomerCode: 0,
      oldcc: 0,
      oldsalerate: 0.00,
      oldsalerate: 0.00,
      Salerate: 0.00,
      Readyforsale: auctionValue === "N" ? "Y" : "N",
      Auction: user.Auction,
      sold: user.sold || "N",
      salebilldocno: user.salebilldocno || 0,
      ApprovedDate: user.ApprovedDate,
      RejectDate: user.RejectDate,
      SrNo: user.SrNo,
      SaudaDate: auctionValue === "N" ? new Date().toISOString().split("T")[0] : "",

    }));

    const requestData = {
      headData,
      detailData,
    };

    try {
      if (isEditMode) {
        const updateApiUrl = `${API_URL}/Update_AwakEntry?Id=${newId}`;
        console.log("newId", newId)
        const response = await axios.put(updateApiUrl, requestData);

        // unlockRecord();
        Swal.fire({
          title: "Success!",
          text: "Record updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });

        setTimeout(() => {
          window.onbeforeunload = null;
          window.location.reload();
        }, 1000);
        navigate(`/Awakentry-api?navigatedRecord=${formData.Doc_No}`);
      } else {
        const response = await axios.post(
          `${API_URL}/insert_Awakentry`,
          requestData
        );
        Swal.fire({
          title: "Success!",
          text: "Record saved successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setIsEditing(true);

        setTimeout(() => {
          window.location.reload();
        }, 1000);
        navigate(`/Awakentry-api?navigatedRecord=${formData.Doc_No}`);
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error occurred while saving data");
    } finally {
      setIsEditing(false);
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    try {

      const usage = await checkAwakNoUsage(formData.Doc_No);

      if (usage.isUsed) {
        Swal.fire({
          icon: "error",
          title: "Cannot Delete",
          text: "This Doc No is already used in Awak Advance. You cannot delete it.",
          confirmButtonColor: "#d33",
        });
        return;
      }


      const isUsed = await checkGulSalebillUsage(formData.Doc_No);

      if (isUsed) {
        Swal.fire({
          icon: "error",
          title: "Cannot Delete",
          text: "This Doc No is already used in Gul Sale Bill. You cannot delete it.",
          confirmButtonColor: "#d33",
        });
        return;
      }




      // if (
      //   await OutwordPostDateRecordLock(
      //     formData.doc_date,
      //     // Post_Date,
      //     // Outword_Date
      //   )
      // ) {
      //   return;
      // }

      // if (parseInt(formData.doc_no) !== 0) {
      //   Swal.fire({
      //     title: "Error",
      //     text: `Couldn't delete this record it is currently referenced in DO No. ${formData.DO_No}`.trim(),
      //     icon: "error",
      //     confirmButtonText: "OK",
      //   });
      //   return;
      // }

      // if (parseInt(formData.einvoiceno) !== "" && formData.ackno !== "") {
      //   Swal.fire({
      //     icon: "warning",
      //     text: "E-Invoice has already been generated for this record.Cannot Delete.",
      //     confirmButtonColor: "#d33",
      //   });
      //   return;
      // }

      // if (formData.EWay_Bill_No !== "") {
      //   Swal.fire({
      //     icon: "warning",
      //     text: "E-WayBill has already been generated for this record.Cannot Delete.",
      //     confirmButtonColor: "#d33",
      //   });
      //   return;
      // }

      // try {

      const response = await axios.get(
        `${API_URL}/AwakEntryByid?Id=${newId}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
      );

      const data = response.data;
      // const isLockedNew = data.last_head_data.LockedRecord;
      // const isLockedByUserNew = data.last_head_data.LockedUser;

      // if (isLockedNew) {
      //   Swal.fire({
      //     title: "Record Locked",
      //     text: `This record is locked by ${isLockedByUserNew}`,
      //     icon: "warning",
      //     confirmButtonText: "OK",
      //   });
      //   return;
      // }

      const result = await Swal.fire({
        title: "Are you sure?",
        text: `Do you really want to delete this Doc No: ${formData.Doc_No}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        cancelButtonText: "Cancel",
        confirmButtonText: "Delete",
        reverseButtons: true,
        focusCancel: true,
      });

      if (result.isConfirmed) {
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setIsLoading(true);

        const deleteApiUrl = `${API_URL}/delete_AwakEntry_byid?Id=${newId}&Company_Code=${companyCode}&Doc_No=${formData.Doc_No}&Year_Code=${Year_Code}`;
        const deleteResponse = await axios.delete(deleteApiUrl);

        if (deleteResponse.status === 200) {
          if (deleteResponse.data) {
            Swal.fire({
              title: "Deleted!",
              text: "Data deleted successfully!",
              icon: "success",
              confirmButtonText: "OK",
            });
            const docNoNum = parseInt(formData.Doc_No);
            if (!docNoNum || docNoNum <= 1) {
              handleAddOne();
            } else {

              handleCancel();
            }
          }
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to delete the record.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Your record is safe 🙂",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error during API call:", error);
      Swal.fire({
        title: "Error",
        text: `There was an error during the deletion: ${error.message}`,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  //Common Feilds that we haev to set the record on the navigations.
  const NavigationSetFields = (headData, detailData) => {
    const details = detailData[0];
    newId = headData.Id;
    partyName = details.partyName;
    partyCode = headData.Ac_code;
    unitName = details.unitname;
    unitCode = details.unitaccode;
    billToName = details.billtoname;
    billToCode = headData.Bill_To;
    gstrate = details.gstrate;
    gstRateCode = headData.GstRateCode;
    millName = details.millname;
    millCode = headData.mill_code;
    itemName = details.ItemName;
    LineName = details.LineName
    item_code = details.System_Code;
    brandName = details.LineName;
    lineCode = details.Line_code;
    brokerCode = headData.Broker_code
    brokerName = details.BrokerName;
    transportCode = details.transportaccode;
    transportName = details.transportname;
    millgstno = details.MillGSTNo;
    gstName = details.GSTName;
    godownCode = headData.Godown_code;
    godownName = details.GoDownName;
    gc = headData.gc;

    setFormData((prevData) => ({
      ...prevData,
      ...headData,
    }));

    setLastTenderData(headData || {});
    setLastTenderDetails(detailData || []);
  };

  // handle cancel get last record data and set to
  const handleCancel = async () => {
    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setCancelButtonClicked(true);

    try {
      const response = await axios.get(
        `${API_URL}/get_lastawak_navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}`
      );
      if (response.status === 200) {
        const data = response.data;
        NavigationSetFields(data.last_head_data, data.last_details_data);
        setIsChecked(true);
        // unlockRecord();
      } else {
        console.error(
          "Failed to fetch last data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  // handle back button to navigate to the dashboard page.
  const handleBack = () => {
    navigate("/Awaka-Entry-utility");
  };

  // Navigation Funtionality
  const handleFirstButtonClick = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/get_firstawak_navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}`
      );
      if (response.status === 200) {
        const data = response.data;
        NavigationSetFields(data.first_head_data, data.first_details_data);
      } else {
        console.error(
          "Failed to fetch first tender data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleLastButtonClick = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/get_lastawak_navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}`
      );
      if (response.status === 200) {
        const data = response.data;
        NavigationSetFields(data.last_head_data, data.last_details_data);
      } else {
        console.error(
          "Failed to fetch last tender data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleNextButtonClick = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/get_nextAwak_navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}&Doc_No=${formData.Doc_No}`
      );
      if (response.status === 200) {
        const data = response.data;
        NavigationSetFields(data.next_head_data, data.next_details_data);
      } else {
        console.error(
          "Failed to fetch next tender data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handlePreviousButtonClick = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/get_previousawak_navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}&Doc_No=${formData.Doc_No}`
      );

      if (response.status === 200) {
        const data = response.data;
        NavigationSetFields(
          data.previous_head_data,
          data.previous_details_data
        );
      } else {
        console.error(
          "Failed to fetch previous tender data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (selectedRecord) {
      handlerecordDoubleClicked();
    } else if (
      navigatedRecord &&
      !isNaN(navigatedRecord) &&
      parseInt(navigatedRecord) > 0
    ) {
      handleNavigateRecord();
    } else {
      handleAddOne();
    }
  }, [selectedRecord, navigatedRecord]);

  const handlerecordDoubleClicked = async () => {

    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setCancelButtonClicked(true);
    try {
      const response = await axios.get(
        `${API_URL}/AwakEntryByid?Id=${selectedRecord.Id}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
      );
      if (response.status === 200) {
        const data = response.data;

        newId = data.Headdata.Id;
        partyName = data.Detaildata[0].partyName;
        partyCode = data.Headdata.Ac_code;
        unitName = data.Detaildata[0].unitname;
        unitCode = data.Detaildata[0].unitaccode;
        billToName = data.Detaildata[0].billtoname;
        billToCode = data.Headdata.Bill_To;
        gstrate = data.Detaildata[0].gstrate;
        gstRateCode = data.Headdata.GstRateCode;
        millName = data.Detaildata[0].millname;
        millCode = data.Headdata.mill_code;
        itemName = data.Detaildata[0].ItemName;
        LineName = data.Detaildata[0].LineName;
        item_code = data.Detaildata[0].System_Code;
        lineCode = data.Detaildata[0].Line_code;
        brokerCode = data.Headdata.Broker_code;
        brokerName = data.Detaildata[0].BrokerName;
        transportCode = data.Detaildata[0].transportaccode;
        transportName = data.Detaildata[0].transportname;
        millgstno = data.Detaildata[0].MillGSTNo;
        gstName = data.Detaildata[0].GSTName;
        godownCode = data.Headdata.Godown_code;
        godownName = data.Detaildata[0].GoDownName;
        gc = data.Headdata.gc;

        setFormData((prevData) => ({
          ...prevData,
          ...data.Headdata,
        }));
        setLastTenderData(data.Headdata || {});
        setLastTenderDetails(data.Detaildata || []);
      } else {
        console.error(
          "Failed to fetch last tender data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleNavigateRecord = async () => {
    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setCancelButtonClicked(true);
    try {
      const response = await axios.get(
        `${API_URL}/AwakBy_doc_no?Doc_No=${navigatedRecord}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
      );
      if (response.status === 200) {
        const data = response.data;

        newId = data.last_head_data.Id;
        partyName = data.last_details_data[0].partyName;
        partyCode = data.last_head_data.Ac_code;
        unitName = data.last_details_data[0].unitname;
        unitCode = data.last_details_data[0].unitaccode;
        billToName = data.last_details_data[0].billtoname;
        billToCode = data.last_head_data.Bill_To;
        gstrate = data.last_details_data[0].gstrate;
        gstRateCode = data.last_head_data.GstRateCode;
        millName = data.last_details_data[0].millname;
        millCode = data.last_head_data.mill_code;
        itemName = data.last_details_data[0].itemname;
        LineName = data.last_details_data[0].line_name;
        item_code = data.last_details_data[0].System_Code;
        lineCode = data.last_details_data[0].Line_code;
        brokerCode = data.last_head_data.Broker_code;
        brokerName = data.last_details_data[0].BrokerName;
        transportCode = data.last_details_data[0].transportaccode;
        transportName = data.last_details_data[0].transportname;
        millgstno = data.last_details_data[0].MillGSTNo;
        gstName = data.last_details_data[0].GSTName;
        godownCode = data.last_head_data.Godown_code;
        godownName = data.last_details_data[0].GoDownName;
        gc = data.last_head_data.gc;
        setFormData((prevData) => ({
          ...prevData,
          ...data.last_head_data,
        }));
        setLastTenderData(data.last_head_data || {});
        setLastTenderDetails(data.last_details_data || []);
      } else {
        console.error(
          "Failed to fetch last tender data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Tab") {
      const changeNoValue = event.target.value;
      try {
        const response = await axios.get(
          `${API_URL}/AwakBy_doc_no?Doc_No=${changeNoValue}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
        );
        const data = response.data;

        newId = data.last_head_data.Id;
        partyName = data.last_details_data[0].partyName;
        partyCode = data.last_head_data.Ac_code;
        unitName = data.last_details_data[0].unitname;
        unitCode = data.last_details_data[0].unitaccode;
        billToName = data.last_details_data[0].billtoname;
        billToCode = data.last_head_data.Bill_To;
        gstrate = data.last_details_data[0].gstrate;
        gstRateCode = data.last_head_data.GstRateCode;
        millName = data.last_details_data[0].millname;
        millCode = data.last_head_data.mill_code;
        itemName = data.last_details_data[0].itemname;
        LineName = data.last_details_data[0].line_name;
        item_code = data.last_details_data[0].System_Code;
        lineCode = data.last_details_data[0].Line_code;
        brokerCode = data.last_head_data.Broker_code;
        brokerName = data.last_details_data[0].BrokerName;
        transportCode = data.last_details_data[0].transportaccode;
        transportName = data.last_details_data[0].transportname;
        millgstno = data.last_details_data[0].MillGSTNo;
        gstName = data.last_details_data[0].GSTName;
        godownCode = data.last_head_data.Godown_code;
        godownName = data.last_details_data[0].GoDownName;
        gc = data.last_head_data.gc;

        setFormData({
          ...formData,
          ...data.last_head_data,
        });
        setLastTenderData(data.last_head_data || {});
        setLastTenderDetails(data.last_details_data || []);
        setIsEditing(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  //-------------------------------------------- Detail Section Start ----------------------------------------------------
  useEffect(() => {

    if (selectedRecord) {
      setUsers(
        lastTenderDetails.map((detail) => ({
          item: detail.item,
          Item_Code: detail.Item_Code,
          item_Name: detail.item_Name,
          rowaction: "Normal",
          Line_code: detail.Line_code,
          line_name: detail.line_name,
          lc: detail.lc,
          ic: detail.ic,
          id: detail.Id,
          Id: detail.Id,
          pata: detail.pata,
          narration: detail.narration,
          Awak_Qty: detail.Awak_Qty,
          bags: detail.bags,
          wt: detail.wt,
          netwt: detail.netwt,
          despatched: detail.despatched,
          balance: detail.balance,
          item_Amount: detail.item_Amount,
          AuctionMark: detail.AuctionMark,
          AuctionDate: detail.AuctionDate,
          Customer_Code: detail.Customer_Code,
          cc: detail.cc,
          oldCustomerCode: detail.oldCustomerCode,
          oldcc: detail.oldcc,
          oldsalerate: detail.oldsalerate,
          Salerate: detail.Salerate,
          Readyforsale: detail.Readyforsale,
          Auction: detail.Auction,
          detail_id: detail.detail_id,
          SaudaDate: detail.SaudaDate,
        }))
      );
    }
  }, [selectedRecord, lastTenderDetails]);

  useEffect(() => {
    const updatedUsers = lastTenderDetails.map((detail) => ({
      item: detail.item,
      Item_Code: detail.Item_Code,
      item_Name: detail.ItemName,
      rowaction: "Normal",
      Line_code: detail.Line_code,
      line_name: detail.LineName,
      lc: detail.lc,
      ic: detail.ic,
      id: detail.Id,
      Id: detail.Id,
      pata: detail.pata,
      narration: detail.narration,
      Awak_Qty: detail.Awak_Qty,
      bags: detail.bags,
      wt: detail.wt,
      netwt: detail.netwt,
      despatched: detail.despatched,
      balance: detail.balance,
      item_Amount: detail.item_Amount,
      AuctionMark: detail.AuctionMark,
      AuctionDate: detail.AuctionDate,
      Customer_Code: detail.Customer_Code,
      cc: detail.cc,
      oldCustomerCode: detail.oldCustomerCode,
      oldcc: detail.oldcc,
      oldsalerate: detail.oldsalerate,
      Salerate: detail.Salerate,
      Readyforsale: detail.Readyforsale,
      Auction: detail.Auction,
      detail_id: detail.detail_id,
      SaudaDate: detail.SaudaDate,
    }));
    setUsers(updatedUsers);
  }, [lastTenderDetails]);

  const calculateDetails = (Awak_Qty, wt) => {
    const netwt = Awak_Qty * wt;
    const roundedNetwt = Math.round(netwt);
    return { netwt: roundedNetwt };
  };

  const calculateTotalnetwt = (users) => {
    return users
      .filter((user) => user.rowaction !== "delete" && user.rowaction !== "DNU")
      .reduce((sum, user) => sum + parseFloat(user.netwt || 0), 0);
  };



  const handleChangeDetail = (event) => {
    const { name, value } = event.target;

    setFormDataDetail((prevDetail) => {
      let updatedDetail = {
        ...prevDetail,
        [name]: value,
      };

      // 🔹 Handle Awak_Qty logic
      if (name === "Awak_Qty") {
        const Awak_Qty_num = parseFloat(value) || 0;
        const wt_num = parseFloat(updatedDetail.wt) || 0;

        const { netwt } = calculateDetails(Awak_Qty_num, wt_num);

        updatedDetail.netwt = netwt;

        // Auto update pata only if not overridden manually
        if (!isPalaManuallyChanged) {
          updatedDetail.pata = value;
        }
      }

      // 🔹 Handle Pala Manual Change
      if (name === "pata") {
        setIsPalaManuallyChanged(true);
      }

      return updatedDetail;
    });
  };

  const addUser = async () => {

    setTimeout(() => {
      addButtonRef.current.focus();
    }, 200)
    if (itemCode === "" && formDataDetail.Line_code === "" || line_code === "") {
      Swal.fire({
        icon: "warning",
        text: "Please Select Item And Line.",
        confirmButtonColor: "#d33",
      });
      return false;
    }
    const maxDetailId =
      users.length > 0
        ? Math.max(...users.map((user) => user.detail_id)) + 1
        : 1;
    const newUser = {
      id: users.length > 0 ? Math.max(...users.map((user) => user.id)) + 1 : 1,
      Item_Code: itemCode,
      item_Name: item_Name,
      ic: itemCodeAccoid,
      Line_code: line_code,
      lc: LineAccoid,
      line_name: line_name,
      ...formDataDetail,
      detail_id: maxDetailId,
      rowaction: "add",
    };

    const updatedUsers = [...users, newUser];
    setUsers(updatedUsers);

    const netTotal = calculateDetails(updateUser);
    // const netQuantal = calculateNetQuantal(updatedUsers);

    const total = calculateTotals(updatedUsers);
    const netquat = total.totalQty;
    let updatedFormData = {
      ...formData,
      AwakQty: netquat,
      // subTotal: subtotal,
    };
    setFormData(updatedFormData);
    closePopup();
  };

  const updateUser = async () => {
    setTimeout(() => {
      addButtonRef.current.focus();
    }, 300)
    const updatedUsers = users.map((user) => {
      if (user.id === selectedUser.id) {
        const updatedRowaction =
          user.rowaction === "Normal" ? "update" : user.rowaction;
        return {
          ...user,
          Line_code: line_code,
          line_name: line_name,
          Item_Code: itemCode,
          item_Name: item_Name,
          packing: formDataDetail.packing,
          bags: formDataDetail.bags,
          Awak_Qty: formDataDetail.Awak_Qty,
          wt: formDataDetail.wt,
          netwt: formDataDetail.netwt,
          balance: formDataDetail.balance,
          sold: formDataDetail.sold,
          pata: formDataDetail.pata,
          narration: formDataDetail.narration,
          ic: itemCodeAccoid,
          lc: LineAccoid,
          AuctionMark: formDataDetail.AuctionMark,
          AuctionDate: formDataDetail.AuctionDate,
          Customer_Code: formDataDetail.Customer_Code,
          cc: formDataDetail.cc,
          oldCustomerCode: formDataDetail.oldCustomerCode,
          oldcc: formDataDetail.oldcc,
          oldsalerate: formDataDetail.oldsalerate,
          Salerate: formDataDetail.Salerate,
          Readyforsale: formDataDetail.Readyforsale,
          Auction: formDataDetail.Auction,
          detail_id: user.detail_id,
          SaudaDate: formDataDetail.SaudaDate,
          rowaction: updatedRowaction,

        };
      } else {
        return user;
      }
    });

    setUsers(updatedUsers);

    const netTotal = calculateDetails(updateUser);

    // const netQuantal = calculateNetQuantal(updatedUsers);

    const total = calculateTotals(updatedUsers);
    const netquat = total.totalQty;
    let updatedFormData = {
      ...formData,
      AwakQty: netquat,
      // subTotal: subtotal,
    };


    setFormData(updatedFormData);
    closePopup();
  };


  const calculateTotals = (users) => {
    return users.reduce(
      (totals, user) => {
        if (user.rowaction !== "delete" && user.rowaction !== "DNU") {
          totals.totalQty += parseFloat(user.Awak_Qty || 0.00);
          totals.totalbal += parseFloat(user.balance || 0);
        }
        return totals;
      },
      { totalQty: 0, totalbal: 0, }
    );
  };

  const { totalbal, totalQty, } = calculateTotals(users);


  const deleteModeHandler = async (user) => {
    try {


      if (user.AuctionMark === "Y") {
        Swal.fire({
          icon: "warning",
          title: "Deletion Not Allowed",
          text: "This record is already marked for Auction. Deleting is disabled.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      const isUsed = await checkGulSalebillForDetailIdUsage(user.Id);

      if (isUsed) {
        Swal.fire({
          icon: "error",
          title: "Cannot Delete",
          text: "This Doc No is already used in Gul Sale Bill. You cannot delete it.",
          confirmButtonColor: "#d33",
        });
        return;
      }
      let updatedUsers;
      if (isEditMode && user.rowaction === "add") {
        setDeleteMode(true);
        setSelectedUser(user);
        updatedUsers = users.map((u) =>
          u.id === user.id ? { ...u, rowaction: "DNU" } : u
        );
      } else if (isEditMode) {
        setDeleteMode(true);
        setSelectedUser(user);
        updatedUsers = users.map((u) =>
          u.id === user.id ? { ...u, rowaction: "delete" } : u
        );
      } else {
        setDeleteMode(true);
        setSelectedUser(user);
        updatedUsers = users.map((u) =>
          u.id === user.id ? { ...u, rowaction: "DNU" } : u
        );
      }
      setUsers(updatedUsers);
      setSelectedUser({});

      const netTotal = calculateDetails(updateUser);

      // const netQuantal = calculateNetQuantal(updatedUsers);

      const total = calculateTotals(updatedUsers);
      const netquat = total.totalQty;
      let updatedFormData = {
        ...formData,
        AwakQty: netquat,
        // subTotal: subtotal,
      };


      setFormData(updatedFormData);
    } catch (error) {
      console.error("Error during API call:", error);
      Swal.fire({
        title: "Error",
        text: `There was an error during the deletion: ${error.message}`,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const openDelete = async (user) => {
    setDeleteMode(true);
    setSelectedUser(user);
    let updatedUsers;
    if (isEditMode && user.rowaction === "delete") {
      updatedUsers = users.map((u) =>
        u.id === user.id ? { ...u, rowaction: "Normal" } : u
      );
    } else {
      updatedUsers = users.map((u) =>
        u.id === user.id ? { ...u, rowaction: "add" } : u
      );
    }
    setUsers(updatedUsers);
    setSelectedUser({});

    const netTotal = calculateDetails(updateUser);

    // const netQuantal = calculateNetQuantal(updatedUsers);

    const total = calculateTotals(updatedUsers);
    const netquat = total.totalQty;
    let updatedFormData = {
      ...formData,
      AwakQty: netquat,
      // subTotal: subtotal,
    };

    setFormData(updatedFormData);
  };

  const openPopup = (mode) => {
    setPopupMode(mode);
    setShowPopup(true);
    if (mode === "add") {
      clearForm();
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedUser({});
    clearForm();
  };

  const clearForm = () => {
    setFormDataDetail({
      // narration: "",
      // packing: 50 || 0,
      Awak_Qty: 0.0,
      wt: 0,
      netwt: 0.0,
      // despatched: 0.0,
      balance: 0.0,
      // item_Amount: 0.0,
      pata: 0.0,
      Id: "",
      detail_id: 1,
    });
    setItemCode("");
    setItemName("");
    setLineCode("");
    setLineName("");
  };

  const editUser = async (user) => {

    try {

      if (user.Readyforsale === "Y") {
        Swal.fire({
          icon: "warning",
          title: "Edit Not Allowed",
          text: "This record is already marked for Auction. Editing is disabled.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      const isUsed = await checkGulSalebillForDetailIdUsage(user.Id);

      if (isUsed) {
        Swal.fire({
          icon: "error",
          title: "Cannot Edit",
          text: "This Detail Id is already used in Gul Sale Bill. You cannot Edit it.",
          confirmButtonColor: "#d33",
        });
        return;
      }
      setSelectedUser(user);
      console.log("setSelectedUser(user);", user)
      setItemCode(user.Item_Code);
      setItemName(user.item_Name);
      setLineCode(user.Line_code);
      setLineName(user.line_name);
      setFormDataDetail({
        // narration: user.narration || "",
        // packing: user.packing || 0,
        Awak_Qty: user.Awak_Qty || 0.0,
        wt: user.wt || 0,
        netwt: user.netwt || 0.0,
        balance: user.balance || 0.0,
        despatched: user.despatched || 0.0,
        pata: user.pata || 0.0,
        AuctionMark: user.AuctionMark || "N",
        AuctionDate: user.AuctionDate || "",
        Customer_Code: user.Customer_Code || 0,
        cc: user.cc || 0,
        oldCustomerCode: user.oldCustomerCode || 0,
        oldcc: user.oldcc || 0,
        oldsalerate: user.oldsalerate || 0.0,
        Salerate: user.Salerate || 0.0,
        Readyforsale: user.Readyforsale || auctionValue === "N" ? "Y" : "N",
        Auction: user.Auction || "",
        detail_id: user.detail_id,
        Id: user.Id,
        id: user.Id,
        SaudaDate: user.SaudaDate || auctionValue === "N" ? new Date().toISOString().split("T")[0] : "",

        // item_Amount: user.item_Amount || 0.0,
      });
      openPopup("edit");
    } catch (error) {
      console.error("Error in editUser:", error);
      await Swal.fire({
        title: "Error",
        text: "An unexpected error occurred while editing the user.",
        icon: "error",
      });
    }
  };

  const handleItemCode = (code, accoid, hsn, name, gstcode, Purchase_AC, Sale_AC, RatePer, pac, sac, KgPer, Auction) => {
    console.log("handleItemCode", KgPer, Auction)
    setItemCode(code);
    setItemName(name);
    setItemCodeAccoid(accoid);
    setAuctionValue(Auction);
    let updatedFormDataDetail = {
      ...formDataDetail,
      Item_Code: code,
      ic: accoid,
      Auction: Auction,
    };
    setFormDataDetail(updatedFormDataDetail);
  };

  const handleTableData = (data) => {

    const kgPerKatta = data?.Selected_SystemMaster_data?.KgPerKatta;
    const auction = data?.Selected_SystemMaster_data?.Auction;


    if (auction == 'N') {
      setFormDataDetail((prevDetail) => ({
        ...prevDetail,
        Readyforsale: 'Y',
        SaudaDate: new Date().toISOString().split("T")[0],
      }
      ));

    }

    if (kgPerKatta !== undefined) {
      setFormDataDetail((prevDetail) => ({
        ...prevDetail,
        wt: kgPerKatta,
      }));
    }
  };


  const handleLineCode = (code, accoid, hsn, name, kgper) => {
    console.log("handleItemCode", kgper)
    setLineCode(code);
    setLineName(name);
    setLineAccoid(accoid);
  };

  //Head Section help Functions to manage the Ac_Code and accoid
  const handleframer = async (
    code,
    accoid,
    Name,
    mobile,
    Gst_No,
    TDSApplicable,
    GSTStateCode,
    cityname,
    statename,
  ) => {
    try {
      console.log("handleframer")
      setFramer(code);
      setNewAccoid(accoid);
      setPartyMobNo(mobile);
      let updatedFormData = {
        ...formData,
        Ac_code: code,
        ac: accoid,
        mobile: mobile,
      };
      setIsFarmerSelected(true);

      if (!billToManuallySet) {
        setBroker(code);
        brokerName = Name
        brokerCode = code

        updatedFormData.Broker_code = code;
        updatedFormData.Bc = accoid;
      }

      setFormData(updatedFormData);
    } catch (error) {
      console.error("Error in handleCustomerCode:", error);
    }
  };

  const handleGodownCode = (code, accoid, HSN, name) => {
    setgodowncode(code);
    setgodown_name(name);

    setFormData((prev) => ({
      ...prev,
      Godown_code: code,
      gc: accoid,
    }));
  };


  const handleborker = async (code, accoid) => {
    setBroker(code);
    let updatedFormData = {
      ...formData,
      Broker_code: code,
      Bc: accoid,
    };
    setFormData(updatedFormData);
  };

  const handleBankChange = (field, value) => {
    const updated = { ...bankDetails[0], [field]: value };
    setBankDetails([updated]);

    // Check if any field changed
    setIsDirty(
      ["Bank_Name", "Bank_Ac_No", "IFSC", "Other_Narration"].some(
        (f) => updated[f]?.trim() !== originalBankDetails[f]?.trim()
      )
    );
  };



  const checkIfChanged = (updated) => {
    if (!originalBankDetails) return false;

    const fieldsToCheck = [
      "Bank_Name",
      "Bank_Ac_No",
      "IFSC",
      "Other_Narration",
    ];

    return fieldsToCheck.some(
      (field) => updated[field] !== originalBankDetails[field]
    );
  };


  const handleOpenBankPopup = async () => {
    setBankLoading(true);
    try {
      const response = await axios.get(`${API_URL}/getaccountmasterByid`, {
        params: {
          Company_Code: companyCode,
          Ac_Code: formData.Ac_code,
        },
      });

      const data = response.data;

      if (!data.account_master_data) {
        Swal.fire("Error", "No bank data found", "error");
        return;
      }

      // Bank details for the popup (editable)
      setBankDetails([data.account_master_data]);

      // Keep original to compare changes
      setOriginalBankDetails(JSON.parse(JSON.stringify(data.account_master_data)));

      // Also keep original contact_data from API to send back unchanged
      setOriginalContactData(data.account_detail_data || []);

      setBankPopupOpen(true);
      setIsDirty(false);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Unable to fetch bank details", "error");
    } finally {
      setBankLoading(false);
    }
  };



  const handleUpdateBankDetails = async () => {
    try {
      const updated = bankDetails[0];
      const original = originalBankDetails;

      const accoid = updated.accoid; // from API response
      if (!accoid) {
        Swal.fire("Error", "Account ID missing", "error");
        return;
      }

      // Only include changed fields
      const master_data = {};

      if (updated.Bank_Name?.trim() !== original.Bank_Name?.trim())
        master_data.Bank_Name = updated.Bank_Name.trim();

      if (updated.Bank_Ac_No?.trim() !== original.Bank_Ac_No?.trim())
        master_data.Bank_Ac_No = updated.Bank_Ac_No.trim();

      if (updated.IFSC?.trim() !== original.IFSC?.trim())
        master_data.IFSC = updated.IFSC.trim();

      if (updated.Other_Narration?.trim() !== original.Other_Narration?.trim())
        master_data.Other_Narration = updated.Other_Narration.trim();

      // Include required fields for backend to avoid errors
      master_data.Ac_Code = original.Ac_Code;
      master_data.company_code = original.company_code;
      master_data.Modified_By = username;
      master_data.Modified_Date = new Date().toISOString().split("T")[0];
      master_data.User_Id = User_Id;

      if (Object.keys(master_data).length === 0) {
        Swal.fire("No Changes", "Nothing to update", "info");
        return;
      }

      const payload = {
        master_data,
        contact_data: originalContactData || [],
      };

      const updateApiUrl = `${API_URL}/update-accountmaster?accoid=${accoid}`;
      await axios.put(updateApiUrl, payload);

      Swal.fire("Success", "Bank details updated successfully!", "success");

      setOriginalBankDetails({ ...updated });
      setIsDirty(false);
      setBankPopupOpen(false);

    } catch (error) {
      console.error("Bank update failed:", error);
      Swal.fire("Error", "Failed to update bank details", "error");
    }
  };

  const handleAdjustClick = (row) => {
    setAdjustRow({
      ...row,
      originalAwakQty: row.Awak_Qty   // store only for dialog reference
    });
    setAdjustValue("");
  };

  // const handleAdjustSave = () => {
  //   const value = parseFloat(adjustValue);

  //   if (isNaN(value)) return;

  //   const updatedUsers = users.map((row) => {
  //     if (row.detail_id === adjustRow.detail_id) {
  //       return {
  //         ...row,
  //         Awak_Qty: parseFloat(row.Awak_Qty) + value,
  //         rowaction: "update",
  //       };
  //     }
  //     return row;
  //   });

  //   setUsers(updatedUsers);
  //   setAdjustRow(null);
  // };

  const handleAdjustSave = () => {
    const value = parseFloat(adjustValue);
    if (isNaN(value)) return;

    const updatedUsers = users.map((row) => {
      if (row.detail_id === adjustRow.detail_id) {
        return {
          ...row,
          Awak_Qty: parseFloat(row.Awak_Qty) + value,
          rowaction: row.rowaction === "Normal" ? "update" : row.rowaction,
        };
      }
      return row;
    });

    setUsers(updatedUsers);

    // Recalculate and sync formData.AwakQty
    const totals = calculateTotals(updatedUsers);
    setFormData((prev) => ({
      ...prev,
      AwakQty: totals.totalQty,
    }));

    setAdjustRow(null);
    setAdjustValue("");
  };

  const handleOpenSaleBillInfo = async () => {
    setSaleBillPopupOpen(true);
    setSaleBillLoading(true);
    try {
      const response = await axios.get(`${API_URL}/getdata-GulSaleBillforAwakForm`, {
        params: {
          Company_Code: companyCode,
          Year_Code: Year_Code,
          Doc_No: formData.Doc_No,
          // Doc_No: formData.Doc_No,  // <- add once the backend supports filtering by this Awak record
        },
      });
      setSaleBillData(response.data?.all_data || []);
    } catch (error) {
      console.error("Error fetching Sale Bill info:", error);
      Swal.fire("Error", "Unable to fetch Sale Bill details", "error");
      setSaleBillData([]);
    } finally {
      setSaleBillLoading(false);
    }
  };




  return (
    <>
      <UserAuditInfo
        createdBy={formData.Created_By}
        modifiedBy={formData.Modified_By}
        title={"Awak Entry"}
      />
      <ToastContainer autoClose={500} />
      <br></br>
      <ActionButtonGroup
        handleAddOne={handleAddOne}
        addOneButtonEnabled={addOneButtonEnabled}
        handleSaveOrUpdate={handleSaveOrUpdate}
        saveButtonEnabled={saveButtonEnabled}
        isEditMode={isEditMode}
        handleEdit={handleEdit}
        editButtonEnabled={editButtonEnabled}
        handleDelete={handleDelete}
        deleteButtonEnabled={deleteButtonEnabled}
        handleCancel={handleCancel}
        cancelButtonEnabled={cancelButtonEnabled}
        handleBack={handleBack}
        backButtonEnabled={backButtonEnabled}
        isDeleted={formData.IsDeleted === 0}
        permissions={permissions}
        component={<div style={{ display: 'flex' }} >
          <AwakentryReport Doc_No={formData.Doc_No} disabledFeild={!addOneButtonEnabled} />

          <button
            type="button"
            className="btn btn-primary"
            disabled={!(isFarmerSelected || formData?.Ac_code)}
            onClick={handleOpenBankPopup}
          >
            View Bank Details
          </button>
        </div>}
      />
      <NavigationButtons
        handleFirstButtonClick={handleFirstButtonClick}
        handlePreviousButtonClick={handlePreviousButtonClick}
        handleNextButtonClick={handleNextButtonClick}
        handleLastButtonClick={handleLastButtonClick}
        highlightedButton={highlightedButton}
        isEditing={isEditing}
      />

      <form onSubmit={handleSubmit}>
        <Grid container alignItems="center" spacing={1} mt={0.5}>
          <Grid item xs={12} sm={1}>
            <FormControl fullWidth>
              <TextField
                label="Change No"
                variant="outlined"
                name="changeNo"
                autoComplete="off"
                onKeyDown={handleKeyDown}
                disabled={!addOneButtonEnabled}
                fullWidth
                size="small"
              />
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={1}>
            <FormControl>
              <TextField
                label="Awak No"
                variant="outlined"
                name="Doc_No"
                autoComplete="off"
                value={formData.Doc_No}
                onChange={handleChange}
                disabled
                fullWidth
                size="small"
              />
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={1}>
            <FormControl>
              <TextField
                inputRef={inputRef}
                type="date"
                label="Date"
                variant="outlined"
                name="Doc_Date"
                value={formData.Doc_Date}
                onChange={handleChange}
                disabled={!isEditing && addOneButtonEnabled}
                firstInputRef={firstInputRef}
                fullWidth
                size="small"
                InputLabelProps={{
                  style: { fontSize: "14px" },
                }}
                InputProps={{
                  style: { fontSize: "12px", height: "40px" },
                }}
              />
            </FormControl>
          </Grid>
        </Grid>

        <div className="SugarSaleBill-row" style={{ marginTop: "10px" }}>
          <label htmlFor="Bill_From" className="SugarSaleBillLabel">
            Farmer :
          </label>
          <div>
            <div>
              <AccountMasterHelp
                onAcCodeClick={handleframer}
                CategoryName={partyName}
                CategoryCode={partyCode}
                name="Ac_code"
                Ac_type={[]}
                disabledFeild={!(isEditing && !isEditMode)}
              />
            </div>
          </div>
        </div>

        {bankPopupOpen && (
          <div
            className="sugar-salebill-modal"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="sugar-salebill-modal-dialog" role="document">
              <div className="modal-content">
                <div className="sugar-salebill-modal-header">
                  <h5 className="sugar-salebill-modal-title">Bank Details</h5>
                  <button
                    type="button"
                    onClick={() => setBankPopupOpen(false)}
                    className="modal-close-btn"
                  >
                    &times;
                  </button>
                </div>

                {/* Body */}
                <div className="sugar-salebill-body">
                  {bankDetails.length > 0 ? (
                    <form>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            label="Account Name"
                            value={bankDetails[0].Ac_Name_E}
                            onChange={(e) => handleBankChange("Ac_Name_E", e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                            disabled
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            label="Bank Name"
                            value={bankDetails[0].Bank_Name}
                            onChange={(e) => handleBankChange("Bank_Name", e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            label="Account No"
                            value={bankDetails[0].Bank_Ac_No}
                            onChange={(e) => handleBankChange("Bank_Ac_No", e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            label="IFSC"
                            value={bankDetails[0].IFSC}
                            onChange={(e) => handleBankChange("IFSC", e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            label="Other Narration"
                            value={bankDetails[0].Other_Narration}
                            onChange={(e) => handleBankChange("Other_Narration", e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                          />
                        </Grid>
                      </Grid>
                    </form>
                  ) : (
                    <p>No bank data found</p>
                  )}
                </div>

                {/* Footer */}
                <div className="modal-footer">
                  <button
                    className="btn-save"
                    disabled={!isDirty}
                    onClick={handleUpdateBankDetails}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="SugarSaleBill-row">
          <label htmlFor="Bill_To" className="SugarSaleBillLabel">
            BROKER:
          </label>
          <div>
            <div>
              <AccountMasterHelp
                onAcCodeClick={handleborker}
                CategoryName={brokerName}
                CategoryCode={brokerCode}
                name="Broker_code"
                Ac_type=""
                disabledFeild={!(isEditing && !isEditMode)}
              />
            </div>
          </div>
        </div>
        <div className="SaleBill-row">
          <Grid container spacing={3} mt={1.5}>
            <Grid item xs={1.5}>
              <TextField
                label="Truck No"
                variant="outlined"
                name="Truck_No"
                autoComplete="off"
                value={formData.Truck_No}
                onChange={handleChange}
                disabled={!isEditing && addOneButtonEnabled}
                fullWidth
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: 'black',
                    backgroundColor: 'white',
                    opacity: 1,
                    '& .Mui-disabled': {
                      color: 'black',
                      WebkitTextFillColor: 'black',
                      opacity: 1,
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={4} sm={1}>
              <TextField
                label="Mobile No."
                name="mobile"
                variant="outlined"
                autoComplete="off"
                value={formData.mobile}
                onChange={handleChange}
                disabled={!isEditing && addOneButtonEnabled}
                fullWidth
                size="small"
                inputProps={{
                  maxLength: 10,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
              />
            </Grid>

            <div className="SugarSaleBill-row" style={{ marginTop: "6px" }}>
              <label
                htmlFor="Godown_code"
                style={{ fontWeight: "bold", marginLeft: "10px" }}
              >
                Godown :
              </label>
              <div>
                <div>
                  <ItemMasterHelp
                    key={godownCode}
                    name="Godown_code"
                    onAcCodeClick={handleGodownCode}
                    CategoryName={godownName}
                    SystemType="W"
                    CategoryCode={godownCode}
                    disabledField={!isEditing && addOneButtonEnabled}
                  />
                </div>
              </div>
            </div>
          </Grid>
        </div>

        {isLoading && (
          <div className="loading-overlay">
            <div className="spinner-container">
              <SaveUpdateSpinner />
            </div>
          </div>
        )}

        <div style={{ marginTop: "10px" }}>
          <AddButton
            openPopup={openPopup}
            isEditing={isEditing}
            ref={addButtonRef}
            setFocusToFirstField={setFocusToFirstField}
          />
        </div>

        {/*detail part popup functionality and Validation part Grid view */}
        <div className="">
          {showPopup && (
            <div
              className="sugar-salebill-modal"
              role="dialog"
              style={{ display: "block" }}
            >
              <div className="sugar-salebill-modal-dialog" role="document">
                <div className="modal-content">
                  <div className="sugar-salebill-modal-header">
                    <h5 className="sugar-salebill-modal-title">
                      {selectedUser.id ? "Update Awak Entry" : "Add Awak Entry"}
                    </h5>
                    <button
                      type="button"
                      onClick={closePopup}
                      aria-label="Close"
                      style={{
                        width: "40px",
                        height: "45px",
                        borderRadius: "4px",
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="sugar-salebill-body ">
                    <form>
                      <div
                        className="SugarSaleBill-row"

                      >
                        <label
                          htmlFor="Mill_Name"
                          className="SugarSaleBillLabel"
                        >
                          Item Code :
                        </label>
                        <div>
                          <div>
                            <SystemHelpMaster
                              tableData={handleTableData}
                              onAcCodeClick={handleItemCode}
                              CategoryName={item_Name}
                              CategoryCode={itemCode}
                              SystemType="I"
                              name="Item_Code"
                              firstInputRef={firstInputRef}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="SugarSaleBill-row">
                        <label
                          htmlFor="Mill_Name"
                          className="SugarSaleBillLabel"
                        >
                          Line Code :
                        </label>
                        <div>
                          <div>
                            <SystemHelpMaster
                              onAcCodeClick={handleLineCode}
                              CategoryName={line_name}
                              CategoryCode={line_code}
                              SystemType="L"
                              name="Line_code"
                            />
                          </div>
                        </div>
                      </div>
                      <Grid container spacing={2} className="mt-3">
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Awak_Qty"
                            name="Awak_Qty"
                            value={formDataDetail.Awak_Qty}
                            onChange={handleChangeDetail}
                            fullWidth
                            autoComplete="off"
                            variant="outlined"
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Pala"
                            name="pata"
                            type="number"
                            value={formDataDetail.pata}
                            onChange={handleChangeDetail}
                            fullWidth
                            autoComplete="off"
                            variant="outlined"
                            size="small"
                          />
                        </Grid>

                      </Grid>
                    </form>
                  </div>

                  <div className="modal-footer">
                    {selectedUser.id ? (
                      <DetailUpdateButton updateUser={updateUser} />
                    ) : (
                      <DetailAddButtom addUser={addUser} />
                    )}
                    <DetailCloseButton closePopup={closePopup} />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div>
            <TableContainer
              component={Paper}
              className="mt-4"
              sx={{ width: "70%", marginBottom: "50px" }}
            >
              <Table aria-label="user table" >
                <TableHead>
                  <TableRow>
                    <TableCell sx={headerCellStyle}>Actions</TableCell>
                    {/* <TableCell sx={headerCellStyle}>RowAction</TableCell> */}
                    <TableCell sx={headerCellStyle}>ID</TableCell>
                    <TableCell sx={headerCellStyle}>Item</TableCell>
                    <TableCell sx={headerCellStyle}>Item Name</TableCell>
                    <TableCell sx={headerCellStyle}>Line Name</TableCell>
                    <TableCell sx={headerCellStyle}>Awak Qty</TableCell>
                    <TableCell sx={headerCellStyle}>Pala</TableCell>
                    <TableCell sx={headerCellStyle}>Balance</TableCell>
                    <TableCell sx={headerCellStyle}>Sold</TableCell>
                    <TableCell sx={headerCellStyle}>Adjust Quantity</TableCell>
                    <TableCell sx={headerCellStyle}>Sale Bill Info</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((user) => (
                    <TableRow key={user.id}>
                      <TableCell sx={{ padding: "0px 1px" }}>
                        {user.rowaction === "add" ||
                          user.rowaction === "update" ||
                          user.rowaction === "Normal" ? (
                          <>
                            <EditButton
                              editUser={editUser}
                              user={user}
                              isEditing={isEditing}
                            />
                            <DeleteButton
                              deleteModeHandler={deleteModeHandler}
                              user={user}
                              isEditing={isEditing}
                            />
                          </>
                        ) : user.rowaction === "DNU" ||
                          user.rowaction === "delete" ? (
                          <OpenButton openDelete={openDelete} user={user} />
                        ) : null}
                      </TableCell>
                      {/* <TableCell>{user.rowaction}</TableCell> */}
                      <TableCell
                        sx={{ padding: "0px 1px", textAlign: "center" }}
                      >
                        {user.detail_id}
                      </TableCell>
                      <TableCell
                        sx={{ padding: "0px 1px", textAlign: "center" }}
                      >
                        {user.Item_Code}
                      </TableCell>
                      <TableCell
                        sx={{ padding: "0px 1px", textAlign: "center" }}
                      >
                        {user.item_Name}
                      </TableCell>
                      <TableCell
                        sx={{ padding: "0px 1px", textAlign: "center" }}
                      >
                        {user.line_name}
                      </TableCell>
                      <TableCell
                        sx={{ padding: "0px 1px", textAlign: "center" }}
                      >
                        {user.Awak_Qty}
                      </TableCell>
                      <TableCell
                        sx={{ padding: "0px 1px", textAlign: "center" }}
                      >
                        {user.pata}
                      </TableCell>

                      <TableCell
                        sx={{ padding: "0px 1px", textAlign: "center" }}
                      >
                        {user.balance}
                      </TableCell>
                      <TableCell
                        sx={{ padding: "0px 1px", textAlign: "center" }}
                      >
                        {user.despatched}
                      </TableCell>
                      <TableCell sx={{ padding: "0px 1px", textAlign: "center" }}>
                        <Button
                          variant="contained"
                          size="small"
                          disabled={!isEditing && addOneButtonEnabled}
                          onClick={() => handleAdjustClick(user)}
                        >
                          Adjust
                        </Button>

                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          size="small"
                          color="secondary"
                          sx={{ ml: 10 }}
                          onClick={handleOpenSaleBillInfo}
                        >
                          Sale Bill Info
                        </Button>

                      </TableCell>

                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "right" }}
                    >
                      Total:
                    </TableCell>
                    <TableCell sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "center" }}>
                      {totalQty.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "center" }}>
                      {totalbal.toFixed(2)}
                    </TableCell>

                    <TableCell colSpan={4}></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Dialog open={!!adjustRow} onClose={() => setAdjustRow(null)}>
                <DialogTitle>Adjust Awak Qty</DialogTitle>
                {/* <Typography sx={{ mb: 1, textAlign: "center"}}>
                  Actual Qty: {adjustRow?.originalAwakQty}
                </Typography>

                <Typography sx={{ mb: 2, textAlign: "center"}}>
                  Current Qty: {adjustRow?.Awak_Qty}
                </Typography> */}
                <DialogContent>
                  <TextField
                    label="Enter + or - Value"
                    type="number"
                    fullWidth
                    value={adjustValue}
                    onChange={(e) => setAdjustValue(e.target.value)}
                    disabledField={!isEditing && addOneButtonEnabled}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setAdjustRow(null)}>Cancel</Button>
                  <Button variant="contained" onClick={handleAdjustSave}>
                    Save
                  </Button>
                </DialogActions>

              </Dialog>
              <Dialog
                open={saleBillPopupOpen}
                onClose={() => setSaleBillPopupOpen(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle>
                  Sale Bill Info
                  <IconButton
                    aria-label="close"
                    onClick={() => setSaleBillPopupOpen(false)}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                  {saleBillLoading ? (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                      <SaveUpdateSpinner />
                    </div>
                  ) : saleBillData.length === 0 ? (
                    <Typography sx={{ textAlign: "center", padding: "20px" }}>
                      No Sale Bill records found.
                    </Typography>
                  ) : (
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={headerCellStyle}>Bill No</TableCell>
                            <TableCell sx={headerCellStyle}>Bill Date</TableCell>
                            <TableCell sx={headerCellStyle}>Item</TableCell>
                            <TableCell sx={headerCellStyle}>Quantity</TableCell>
                            <TableCell sx={headerCellStyle}>Net Weight</TableCell>
                            <TableCell sx={headerCellStyle}>Rate</TableCell>
                            <TableCell sx={headerCellStyle}>Amount</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {saleBillData.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell align="center">{row.doc_no}</TableCell>
                              <TableCell align="center">{row.doc_date}</TableCell>
                              <TableCell align="center">{row.System_Name_E}</TableCell>
                              <TableCell align="center">{row.Quantity}</TableCell>
                              <TableCell align="center">{row.Net_weight}</TableCell>
                              <TableCell align="center">{row.Rate}</TableCell>
                              <TableCell align="center">{row.Amount}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </DialogContent>
              </Dialog>
            </TableContainer>
          </div>
        </div>
      </form>
    </>
  );
};

export default AwakEntry;
